<div class="select-tags-holder vertical-align-middle" *ngIf="freeTextEnabled || (tags && tags.length > 0)">
    <ng-container *rlNoPrivileges="['RL_LEGANTO_GUEST']">
        <button rlStopPropagation *ngIf="!addTagsOpen" class="btn btn-link normal-weight no-padding"
            (click)="openTagSelect();" [id]="'add-tag-btn-' + uniqueId" [tooltip]="'add.tag' | translate" [rlAria]
            [rlTabIndex]>
            <i class="fa fa-tags" attr.aria-hidden="true"></i>
            {{label | translate}}
        </button>
    </ng-container>
    <div class="justify-content flex-wrap">
        <div class="flex-basis">
            <div class="tags-list-holder" *ngIf="addTagsOpen">
                <input class="form-control" rlStopPropagation [(ngModel)]="tag" typeaheadOptionField="tag.name"
                    [typeahead]="tags" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0"
                    placeholder="{{'add.tag' | translate}}" [typeaheadItemTemplate]="customItemTemplate" [typeaheadIsFirstItemActive]="true"
                    (typeaheadOnSelect)="select($event.item)" (typeaheadOnBlur)="blur($event)"
                    (keydown.space)="addSpaceToTerm($event)" (keyup.escape)="resetForm()"
                    (keydown.enter)="addPrivateTag($event)" (keydown)="keyDown($event)" [rlFocusMe]="true" />
            </div>
        </div>
        <div class="flex-basis" *ngIf="shortLengthWarn">
            <span class="vertical-webkit-baseline">{{'addTag.warn.length' | translate}}</span>
        </div>
    </div>
    <div class="tags-box-holder">
        <!-- tags dropdown -->
        <ng-template #customItemTemplate let-model="item" let-index="index" class="tags-dropdown-holder">
            <div class="tag-item" [ngSwitch]="model.type" [id]="'tag-option-' + index">
                <i *ngSwitchCase="'LIBRARY'" class="fa fa-university"></i>
                <i *ngSwitchCase="'PUBLIC'" class="fa fa-graduation-cap"></i>
                <i *ngSwitchCase="'INSTRUCTOR'" class="fa fa-book"></i>
                <i *ngSwitchCase="'LIBRARY_EXTERNAL'" class="fa fa-building-o"></i>
                <span [innerHTML]="model.code | translate | mark:findMarkers(model.code | translate)"></span>
            </div>
        </ng-template>
    </div>
</div>